export const GATSBY_GITLAB_APP_ID = process.env.GATSBY_GITLAB_APP_ID
export const GATSBY_GITLAB_URL = process.env.GATSBY_GITLAB_URL

export const API_URL = process.env.GATSBY_API_URL
export const SITE_URL = typeof location !== 'undefined' ? `${location.protocol}//${process.env.GATSBY_SITE_URL}` : ''

export const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY
export const TAG_PATTERN = '^[a-zA-Z/]+(?:-[/a-zA-Z0-9]+)*$'

export const ROUTE_PATH = {
  services: {
    name: 'Services',
    path: '/what-we-do',
  },
  technologies: {
    name: 'Technology',
    path: '/capabilities',
  },
  press: {
    name: 'Press',
    path: '/company',
  },
  aboutUs: {
    name: 'About Us',
    path: '/about-us',
  },
  connectWithUs: {
    name: 'Connect with Us',
    path: '/contact-us',
  },
}

export type IPath = keyof typeof ROUTE_PATH

// Colors

// eslint-disable-next-line no-shadow
export enum Colors {
  PRIMARY = 'primary',
  VIOLET = 'violet',
  BLUE = 'blue',
  BLUE_DARK = 'blueDark',
  GREEN = 'green',
  GREEN_DARK = 'greenDark',
}

// eslint-disable-next-line no-shadow
export enum TextColors {
  WHITE = 'white',
  DARK = 'dark',
}

export type BackgroundColorType = 'white' | 'grey' | 'dark'

type RecordColors = Record<Colors, string>
type RecordTextColors = Record<TextColors, string>

export const ColorsArray = Object.values(Colors)
export const TextColorsArray = Object.values(TextColors)

export type ColorsType = keyof RecordColors
export type TextColorsType = keyof RecordTextColors
